import React, { useEffect } from "react";
import successAnimationData from "./celebration.json";
import Lottie from "react-lottie";
import {
  Box,
  Button,
  Container,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useRecoilState } from "recoil";
import { selectedMenuItemsState } from "../atoms";

function Success() {
  const { hotelId, shopId, tableId, tableNumber } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [selectedMenuItems, setSelectedMenuItems] = useRecoilState(
    selectedMenuItemsState
  );

  const newOrder = () => {
    setSelectedMenuItems({});
    navigate(`/cat/${hotelId}/${shopId}/${tableId}/${tableNumber}`);
  };

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handlePopState = (event) => {
      event.preventDefault();
      newOrder();
    };

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [hotelId, shopId, tableId, tableNumber]);

  const successAnimation = {
    loop: true,
    autoplay: true,
    animationData: successAnimationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  // Check if orderId exists in location state
  const orderId = location.state?.orderId;

  return (
    <div>
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: isMobile ? 2 : 4,
            mt: 4,
            width: "100%",
            maxWidth: "100%",
          }}
        >
          <Lottie options={successAnimation} height={150} width={150} />
          <Typography
            variant={isMobile ? "h6" : "h5"}
            align="center"
            gutterBottom
            style={{ color: "gray" }}
          >
            {orderId
              ? `Thanks for placing an order. Your order ID is - ${orderId}`
              : "Thanks for placing an order."}
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Button variant="custom-button" onClick={newOrder}>
              Place new order
            </Button>
          </Box>
        </Paper>
      </Container>
    </div>
  );
}

export default Success;
